/**
 * @generated SignedSource<<a5ce1adcdb0d05512bfa2cbbda7ccca8>>
 * @relayHash 9c5e4f86abe648a8b5cad97877f94d28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1c2b0a46e26144b0b66c85d8b1db9e6ed6e393f28fa5ef1815ffccd31641425

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ApprovalsContextWorkflowStatusesQuery$variables = {
  cloudId: string;
  transitionType?: ConfluenceApprovalTransitionType | null | undefined;
};
export type ApprovalsContextWorkflowStatusesQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly color: string | null | undefined;
      readonly description: string | null | undefined;
      readonly icon: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ApprovalsContextWorkflowStatusesQuery = {
  response: ApprovalsContextWorkflowStatusesQuery$data;
  variables: ApprovalsContextWorkflowStatusesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transitionType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "transitionType",
        "variableName": "transitionType"
      }
    ],
    "concreteType": "ConfluenceApprovalsWorkflowStatus",
    "kind": "LinkedField",
    "name": "confluence_contentApprovalStatuses",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "allowsReviews"
      },
      {
        "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
        "kind": "LinkedField",
        "name": "displayProperties",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "icon"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9c5e4f86abe648a8b5cad97877f94d28",
    "id": "d1c2b0a46e26144b0b66c85d8b1db9e6ed6e393f28fa5ef1815ffccd31641425",
    "metadata": {},
    "name": "ApprovalsContextWorkflowStatusesQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextWorkflowStatusesQuery($cloudId:ID!,$transitionType:ConfluenceApprovalTransitionType){confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,description,color,icon}}}"
  }
};
})();

(node as any).hash = "b2867ff8f3806e485c4bf82373fe146f";

export default node;
